import { useState, ChangeEvent } from "react";
import { DropdownChangeEvent } from "primereact/dropdown";
import { MultiSelectChangeEvent } from "primereact/multiselect";
import { PeopleVisibility } from "../../../api/types/people";

interface ProfessionalInfoData {
  needs?: string;
  bio?: string;
  visibility?: PeopleVisibility | null;
  skills?: string[];
}

export const useProfessionalInfo = (initialData?: ProfessionalInfoData) => {
  const [needs, setNeeds] = useState<string>(initialData?.needs || "");
  const [bio, setBio] = useState<string>(initialData?.bio || "");
  const [visibility, setVisibility] = useState<PeopleVisibility | null>(
    initialData?.visibility || null,
  );
  const [skills, setSkills] = useState<string[]>(initialData?.skills || []);

  const handlers = {
    onNeedsChange: (event: ChangeEvent<HTMLInputElement>) =>
      setNeeds(event.target.value),
    onBioChange: (value: string) => setBio(value),
    onVisibilityChange: (event: DropdownChangeEvent) =>
      setVisibility(event.value),
    onSkillsChange: (event: MultiSelectChangeEvent) => setSkills(event.value),
  };

  return {
    values: { needs, bio, visibility, skills },
    handlers,
    setters: { setNeeds, setBio, setVisibility, setSkills },
  };
};
